<template>
  <z-popup v-model="showCondition" position="bottom" class="params-popup" get-container="body">
    <div class="pop-title">
      <span>{{ popTitle || '' }}</span>
      <div class="mask_img" @click="togglePopup">
        <img src="https://pic6.zhuanstatic.com/zhuanzh/1b8afb9f-426f-46dc-92b2-4cc6dcfdcce3.png" />
      </div>
    </div>
    <div class="params-desc">
      <div v-for="(item, index) in qcWikiDesc" :key="index" class="item-desc">
        {{ item }}
      </div>
    </div>
    <div class="pop-wrapper">
      <div v-if="impactDesc && impactDesc.length" class="impactDesc-content">
        <div class="impactDesc-title">使用体验有什么差异？</div>
        <div class="impactDesc-list">
          <div v-for="(item, index) in impactDesc" :key="index" class="item-impactDesc">
            {{ item }}
          </div>
        </div>
      </div>

      <div v-if="standardDefines && standardDefines.length" class="standardDefines">
        <div class="standardDefines-list">
          <div
            v-for="(item, index) in standardDefines"
            :key="index"
            :class="['item-content', item.mark === 1 ? 'active' : '']"
          >
            <div class="item-label">{{ item.qcItemName }}</div>
            <div class="item-value">
              <span v-for="(list, i) in item.defineDesc" :key="i">{{ list }} </span>
            </div>
          </div>
        </div>
      </div>
      <div class="report_photo">
        <img v-if="qcWikiImg" class="img_report" :src="$setPicSize(qcWikiImg, 1000, 1000)" />
      </div>
    </div>
  </z-popup>
</template>

<script>
import Vue from 'vue'
import { computed, defineComponent, ref } from '@vue/composition-api'
import { Popup, Tab, Tabs, Table, PlatformBchEntry, Icon, Button } from '@zz-common/zz-ui'
Vue.use(Popup).use(Tab).use(Tabs).use(Table).use(PlatformBchEntry).use(Icon).use(Button)

export default defineComponent({
  props: {
    dataInfo: {
      type: Object,
      default: () => ({})
    },
    report: {
      type: Object,
      default: () => ({})
    }
  },
  setup() {
    const popTitle = ref('  ')
    const showCondition = ref(false)
    const reportData = ref(null) //

    /**
     * $ 弹窗展示的数据
     */
    const togglePopup = (data) => {
      console.log('togglePopup', data)
      showCondition.value = !showCondition.value
      reportData.value = data
      popTitle.value = `${data.paramName}: ${data.paramValue}`
    }

    /**
     * $ 百科信息
     */
    const qcWikiDesc = computed(() => {
      const qcWikiDesc = reportData.value?.qcWiki?.qcWikiDesc || []
      return qcWikiDesc || ''
    })

    /**
     * $ 网络制式数据  优先取它，没有的话取 解释说明impactDesc数据
     */
    const standardDefines = computed(() => {
      const standardDefines = reportData.value?.qcWiki?.standardDefines || []
      return standardDefines || []
    })

    /**
     * $ 解释说明
     */
    const impactDesc = computed(() => {
      const impactDesc = reportData.value?.qcWiki?.impactDesc || []
      return impactDesc || []
    })

    /**
     * $ 百科图片
     */
    const qcWikiImg = computed(() => {
      return reportData.value?.qcWiki?.qcWikiImg || ''
    })

    return {
      popTitle,
      showCondition,
      togglePopup,
      reportData,
      qcWikiDesc,
      impactDesc,
      standardDefines,
      qcWikiImg
    }
  }
})
</script>

<style lang="scss" scoped>
.params-popup {
  padding-top: 24px;
  .pop-title {
    position: relative;
    box-sizing: border-box;
    height: 148px;
    margin-top: -24px;
    // margin-bottom: 20px;
    padding-top: 25px;
    color: #111;
    font-weight: 600;
    font-size: 28px;
    font-family: PingFangSC-Medium, PingFang SC;
    line-height: 70px;
    text-align: center;
    background: url(//pic1.zhuanstatic.com/zhuanzh/239a2937-a06b-4015-a719-462b7ae5bf28.png)
      no-repeat 0 0;
    background-size: cover;
    span {
      position: absolute;
      bottom: 0;
      left: 32px;
      // transform: translateX(-50%);
    }
    .mask_img {
      position: absolute;
      top: 21px;
      right: 32px;
      width: 48px;
      height: 48px;
      img {
        width: 24px;
        height: 24px;
      }
    }
  }
  .params-desc {
    padding: 0 32px;
    // padding: 0 32px calc(env(safe-area-inset-bottom));
    .item-desc {
      margin-top: 10px;
      margin-bottom: 24px;
      color: #111;
      font-weight: 400;
      font-size: 24px;
      font-family: PingFangSC-Regular, PingFang SC;
      line-height: 40px;
    }
  }
  .pop-wrapper {
    box-sizing: border-box;
    max-height: 70vh;
    padding: 0 32px calc(constant(safe-area-inset-bottom));
    padding: 0 32px calc(env(safe-area-inset-bottom));
    overflow-y: scroll;
    .standardDefines-list {
      overflow: hidden;
      border-radius: 12px;
      .item-content {
        display: flex;
        color: #999;
        font-weight: 400;
        font-size: 26px;
        font-family: PingFangSC-Regular, PingFang SC;
        line-height: 32px;
        .item-label {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 168px;
          margin: 0 0 4px;
          padding: 27px 10px 27px 20px;
          background: #f8f9fd;
          border-right: 4px solid #fff;
        }
        .item-value {
          width: calc(100% - 172px);
          margin-bottom: 4px;
          padding: 27px 10px 27px 20px;
          background: #f8f9fd;
        }
      }
      .active {
        color: #111;

        .item-label {
          font-weight: 600;
          font-family: PingFangSC-Semibold, PingFang SC;
        }
      }
    }
    .impactDesc-content {
      margin-bottom: 20px;
      padding: 28px 32px;
      background: #f8f9fd;
      border-radius: 12px;
      .impactDesc-title {
        margin-bottom: 20px;
        color: #111;
        font-weight: 500;
        font-size: 26px;
        font-family: PingFangSC-Medium, PingFang SC;
        line-height: 32px;
      }
      .impactDesc-list {
        .item-impactDesc {
          margin-bottom: 32px;
          color: #111111;
          font-weight: 400;
          font-size: 24px;
          font-family: PingFangSC-Regular, PingFang SC;
          line-height: 40px;
        }
      }
    }
    .report_photo {
      margin-top: 48px;
      overflow: hidden;
      background: #f8f8f8;
      border-radius: 12px;
      .img_report {
        width: 100%;
        height: auto;
        max-height: 100%;
        border-radius: 12px;
      }
    }
  }
}
</style>
